// extracted by mini-css-extract-plugin
module.exports = {"header":"globalHeroNavStyles_header__pOiL2","content":"globalHeroNavStyles_content__m0LJF","title":"globalHeroNavStyles_title__Yg9Nv"};